export default function LanguageToggle() {
  return (
    <img
      src="/images/landing-v2/features/language-tiles.png"
      alt="Language selector showing Spanish, English (selected), Hindi"
      className="w-full select-none"
      draggable="false"
    />
  );
}
